export const func = {
  checkPermission: (path) => {
    let result = global.category.match(path);
    if (result == null) {
      return false;
    }
    return true;
  },
};
